import { createUseStyles } from 'react-jss';

export default createUseStyles({
  button: {
    position: 'relative',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '-8px',
      top: '-8px',
      borderRadius: '100%',
      width: '48px',
      height: '48px',

      backgroundColor: '#E84118',

      opacity: '0',
      transition: 'opacity 0.25s',
    },

    '&:hover::before': {
      opacity: '0.15',
    },
  },
});
